import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanDeactivate, RouterStateSnapshot } from '@angular/router';
import { ComponentCanDeactivateDirective } from './component-can-deactivate';

@Injectable()
export class CanDeactivateGuard implements CanDeactivate<ComponentCanDeactivateDirective> {
  canDeactivate(component: ComponentCanDeactivateDirective,
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): boolean {

    if (!component.canDeactivate()) {
      if (confirm('Deine Eingaben gehen verloren, willsst Du diese Seite wirklich verlassen?')) {
        return true;
      } else {
        return false;
      }
    }
    return true;
  }
}
